import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";

import { post } from "../../services/smartApiService";


interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({});
const ChangeDateForm: React.FC<HeaderProps> = ({ dataIn, loadTableData }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });
  const { closeModal } = useSiteContext();

  const onSubmit = (data: any) => {
    let url = SESSION_URLS.CHANGE_DATE;
    const formattedData = {
      ...data,
      id: String(data.ID), 
    }
    const subscription = post(url, formattedData).subscribe((response) => {
      //console.log("response form ", response.data);
      closeModal();
      loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "DATE",
      width: 12,
      name: "session_date",
      element: {
        label: "Session Date",
        isRequired: true,
        placeHolder: "Select Date",
        minDate: new Date(),
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default ChangeDateForm;
